import React, { FC } from "react";
import { CheckoutFeedbackQuestionProjection } from "../../../../../projection/checkoutFeedback/checkoutFeedback";
import CheckoutQuestion from "./CheckoutQuestion";

interface CheckoutQuestionsProps {
  readonly checkoutQuestions: CheckoutFeedbackQuestionProjection[];
}

const CheckoutQuestions: FC<CheckoutQuestionsProps> = ({ checkoutQuestions }) => (
  <>
    {checkoutQuestions.map((checkoutQuestion: CheckoutFeedbackQuestionProjection) => (
      <CheckoutQuestion key={checkoutQuestion.id} checkoutQuestion={checkoutQuestion} checkoutQuestionParentId="" />
    ))}
  </>
);

export { CheckoutQuestions };
